import { disabled, hidden }      from '../../button/button.class.scss'
import { bet_interface_open }    from '../../../sass/button/bet.class.scss'
import { BetMinus }              from './button/betInterface.button.minus.class'
import { BetPlus }               from './button/betInterface.button.plus.class'
import { Max }                   from './button/betInterface.button.max.class'
import { Coins }                 from './button/settings/betInterface.button.settings.coins.class'
import { Cash }                  from './button/settings/betInterface.button.settings.cash.class'
import { Interface }             from '../interface.class'
import { arch }                  from '../../../sass/button/arch/button.arch.class.scss'
import { BET_INTERFACE_BUTTONS } from '../../../constants/betInterfaceButton/bet-interface-buttons.constant'
import { BET_VALUES }            from '../../../constants/bet-values/bet-values.constant'

/**
 * @file Defines the {@link BetInterface} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

 /**
  * Class for handling content & functionality of bet interface
  * @extends Interface
  */
  export class BetInterface extends Interface {

    /**
     * Reference to cash button
     * @memberof BetInterface
     * @protected
     * @instance
     * @type {Cash}
     */
    _cash
    
    /**
     * Reference to coins button
     * @memberof BetInterface
     * @protected
     * @instance
     * @type {Coins}
     */
    _coins
    
    /**
     * Reference to max button
     * @memberof BetInterface
     * @protected
     * @instance
     * @type {Max}
     */
    _max
    
    /**
     * Reference to minus button
     * @memberof BetInterface
     * @protected
     * @instance
     * @type {BetMinus}
     */
    _minus

    /**
     * Reference to plus button
     * @memberof BetInterface
     * @protected
     * @instance
     * @type {BetPlus}
     */
    _plus

    /** Initialize bet interface */
     constructor() {

        super('bet')  //Call parent constructor
        this.render() //Render bet interface

        this.topButton('bet') //Create close button

        this._cash  = new Cash()     //Add cash button
        this._coins = new Coins()    //Add coins button
        this._minus = new BetMinus() //Add minus button
        this._plus  = new BetPlus()  //Add plus button
        this._max   = new Max()      //Add max bet button

        //If jurisdiction doesn't allow display in coins
        if (!getCanCoins_()) {
            document.getElementById('body-settings').classList.add('hidden') //Hide bet settings node
        }

    }

    /** Get show */ get show() { return this._show }

    /** Set show */
    set show(v_) {

        super.show = v_ //Set show flag

        //If interface showing
        if (this.show) {

            let text       = document.getElementById('bet-amount')                        //Retrieve bet amount node
            text.innerHTML = balanceManager_.geBalanceObj().currency + BET_VALUES.value() //Display current bet amount in text

            window.newUI.bet().visible = false //Hide bet button

            //Build array containing all bet interface buttons
            let arr = [

                this._cash,
                this._coins,
                this._max,
                this._minus,
                this._max,
                this._plus

            ]

            //For each button in bet interface
            arr.forEach((b_) => {
                
                //If click handler not added for button
                if (!b_.added) {
                    b_.add() //Add click handler to button
                }

            })

            //For each button
            window.newUI.buttons.forEach((b_) => {

                //If interface is showing
                if (this.show) {

                    //If bet button
                    if (b_.id === 'bet') {
                        b_.elem.classList.add(bet_interface_open) //Make bet button inline with minus button
                    }
                    
                    //If menu button
                    if (b_.id === 'menu') {

                        b_.state = 'CLOSE' //Set to close state
                        b_.elem.classList.add(bet_interface_open) //Make menu button inline with minus button

                    }

                    //If button is not autospin or menu
                    if (b_.id !== 'bet' && b_.id !== 'menu') {
                        b_.visible = false //Hide button
                    }

                    b_.id === 'bet' || b_.id === 'menu' ? b_.enable = true : b_.enable = false //Disable all buttons except bet & menu button

                    //If button has text and isn't bet button
                    if (b_.id !== 'bet' && b_.text !== '') {
                        document.getElementById('autospin-text').classList.add(disabled) //Add disabled styling to button text
                    }

                }

            })

            //If displaying in coins
            if (balanceManager_.getShowIncredits()) {
                document.getElementById(BET_INTERFACE_BUTTONS.cash.id).classList.add('off') //Add button setting off styling to cash button
            }

            //Displaying in cash
            else {
                document.getElementById(BET_INTERFACE_BUTTONS.coins.id).classList.add('off') //Add button setting off styling to coins button
            }

        }

        //Interface isn't showing
        else {

            document.getElementById('autospin-text').classList.remove(disabled) //Remove disabled styling from button text
            document.getElementById(arch).classList.remove(hidden)              //Make arch visible (if portrait)

            window.newUI.bet().elem.classList.remove(bet_interface_open) //Apply default bet button styling
            window.newUI.bet().visible = true                            //Show bet button

            //Apply default menu button styling
            window.newUI.menu().state = 'MENU'
            window.newUI.menu().elem.classList.remove(bet_interface_open)

            //If svenska spel
            if ((loginVars.getRegParams().jurisdiction === 'de') || (loginVars.getRegParams().jurisdiction =="se" && gameParams.clientName!="" && gameParams.clientName.indexOf("NYX")>=0  &&  Math.abs(Number(gameParams.site))== 939)) {
                
                window.newUI.autospin().enable  = false //Disable autoplay button
                window.newUI.autospin().visible = false //Hide autoplay button

            }

        }

        this.render() //Render interface

    }

    /**
     * Click handler for closing bet interface
     * @param {object} this_ - Reference to class's scope
     */
    click(this_) {

        let _this = this_  //Store reference to scope
        super.click(_this) //Call parent click method

        //If svenska spel
        if ((loginVars.getRegParams().jurisdiction === 'de') || (loginVars.getRegParams().jurisdiction =="se" && gameParams.clientName!="" && gameParams.clientName.indexOf("NYX")>=0  &&  Math.abs(Number(gameParams.site))== 939)) {

            window.newUI.autospin().enable  = false //Disable autoplay button
            window.newUI.autospin().visible = false //Hide autoplay button

        }
        
        _this.show = false //Hide interface

    }

  }